import ActivityEvent from './activityEvent';

export default class ReplayedEvents {
  public name: string;
  public status: number | null;
  public hasWarnings: boolean;
  public hasErrors: boolean;
  public events: ActivityEvent[];
  constructor() {
    this.name = '';
    this.status = 0;
    this.hasWarnings = false;
    this.hasErrors = false;
    this.events = [] as ActivityEvent[];
  }
}
